import { getAllSensitiveTools } from "@services/sensitiveToolsService"
import { useQuery } from "@tanstack/react-query"

export const useSensitiveTools = () => {
	return useQuery<string[], Error>({
		queryKey: ["sensitiveTools"],
		queryFn: async () => {
			const data = await getAllSensitiveTools()
			return data
		},
		enabled: true,
		staleTime: 5 * 60 * 1000
	})
}
